import { render } from "./NextWeek.vue?vue&type=template&id=17ec3532&scoped=true"
import script from "./NextWeek.vue?vue&type=script&lang=js"
export * from "./NextWeek.vue?vue&type=script&lang=js"

import "./NextWeek.vue?vue&type=style&index=0&id=17ec3532&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-17ec3532"

export default script